import React from 'react';
import Header from '../core/Header';
import Footer from '../core/Footer';
import './UrgentCare.css';
import data1 from '../node/img/data1.png';
import data2 from '../node/img/data_dup.png';
import data3 from '../node/img/data2.png';
import hardware from '../node/img/hardware.png';
import threat1 from '../node/img/threatanalysis.png';
import threat2 from '../node/img/threat_analy.png';
import threat3 from '../node/img/threat_analy2.png';
import threat4 from '../node/img/threat4.png';
import network from '../node/img/network_diagram.png';
import asset from '../node/img/asset.png';

const UrgentCare = () => {
  return (
    <div className="urgentcare-page">
      <Header />

      <article className="urgentcare-toc-wrap">
        <div className="toc">
          <h2>Table of Contents</h2>
          <h4>
            Authors: Kennashka DeSilva, Elianys Roca, Jonathon Campos, Jose Dario Lara, and Jorge
            Alejandro Brito
          </h4>

          <ol>
            <li>
              <a href="#pro1" title="Go to Problem Definition I">
                <span className="chapter">Problem Definition I</span>
                <span className="toc-page">02</span>
              </a>
              <ol>
                <li>
                  <a href="#pro1_1" title="Go to Description of the Business Context">
                    <span className="chapter">Description of the Business Context</span>
                    <span className="toc-page">02</span>
                  </a>
                </li>
                <li>
                  <a href="#pro1_2" title="Go to Scope">
                    <span className="chapter">Scope</span>
                    <span className="toc-page">02</span>
                  </a>
                </li>
                <li>
                  <a href="#pro1_3" title="Go to Asset Inventory">
                    <span className="chapter">Asset Inventory</span>
                    <span className="toc-page">02</span>
                  </a>
                </li>
              </ol>
            </li>

            <li>
              <a href="#pro2" title="Go to Problem Definition II">
                <span className="chapter">Problem Definition II</span>
                <span className="toc-page">03</span>
              </a>
              <ol>
                <li>
                  <a href="#pro2_1" title="Go to Threat Analysis">
                    <span className="chapter">Threat Analysis</span>
                    <span className="toc-page">04</span>
                  </a>
                </li>
                <li>
                  <a href="#pro2_2" title="Go to Current Security Posture">
                    <span className="chapter">Current Security Posture</span>
                    <span className="toc-page">06</span>
                  </a>
                </li>
              </ol>
            </li>

            <li>
              <a href="#design1" title="Go to Design & Specification I">
                <span className="chapter">Design & Specification I</span>
                <span className="toc-page">08</span>
              </a>
              <ol>
                <li>
                  <a href="#design1_1" title="Go to Design Approach">
                    <span className="chapter">Design Approach</span>
                    <span className="toc-page">09</span>
                  </a>
                </li>
                <li>
                  <a href="#design1_2" title="Go to Design and Development">
                    <span className="chapter">Design and Development</span>
                    <span className="toc-page">09</span>
                  </a>
                </li>
                <li>
                  <a href="#design1_3" title="Go to Encryption and File Password-protection">
                    <span className="chapter">Encryption and File Password-protection</span>
                    <span className="toc-page">10</span>
                  </a>
                </li>
                <li>
                  <a href="#design1_4" title="Go to Residual Risk and Other Considerations">
                    <span className="chapter">Residual Risk and Other Considerations</span>
                    <span className="toc-page">10</span>
                  </a>
                </li>
              </ol>
            </li>

            <li>
              <a href="#design2" title="Go to Design & Specification II">
                <span className="chapter">Design & Specification II</span>
                <span className="toc-page">11</span>
              </a>
              <ol>
                <li>
                  <a href="#design2_1" title="Go to Selected Security Controls">
                    <span className="chapter">Selected Security Controls</span>
                    <span className="toc-page">12</span>
                  </a>
                </li>
              </ol>
            </li>

            <li>
              <a href="#implement" title="Go to Implementation">
                <span className="chapter">Implementation</span>
                <span className="toc-page">13</span>
              </a>
              <ol>
                <li>
                  <a href="#implement_1" title="Go to Selected Security Control">
                    <span className="chapter">Selected Security Control</span>
                    <span className="toc-page">14</span>
                  </a>
                </li>
                <li>
                  <a href="#implement_2" title="Go to Implementation of Security Control">
                    <span className="chapter">Implementation of Security Control</span>
                    <span className="toc-page">15</span>
                  </a>
                </li>
                <li>
                  <a
                    href="#implement_3"
                    title="Go to Summary of Proposed Policies in Accordance with HIPAA Guidelines"
                  >
                    <span className="chapter">
                      Summary of Proposed Policies in Accordance with HIPAA Guidelines
                    </span>
                    <span className="toc-page">15</span>
                  </a>
                </li>
              </ol>
            </li>

            <li>
              <a href="#conclusion" title="Go to Conclusion">
                <span className="chapter">Conclusion</span>
                <span className="toc-page">16</span>
              </a>
            </li>
          </ol>
        </div>
        <hr />
      </article>

      <main className="container urgentcare-content">
        <p>
          This cybersecurity engagement was completed as a final capstone project.
        </p>

        <h2 id="pro1">Problem Definition I</h2>

        <h4 id="pro1_1">Description of the Business Context</h4>
        <p>
          Established in 2020, Hialeah Urgent Care (HUC) is an urgent care medical facility providing
          treatment and care for Hialeah and Hialeah Gardens residents. Their business model is to
          provide low-level emergency care services so patients do not need to visit a hospital or wait
          for appointments with their primary care physicians.
        </p>
        <p>
          Due to the pandemic, frequent cyberattacks affecting healthcare organizations, and federal and
          state compliance requirements, HUC is evaluating a more secure and scalable Remote Desktop
          Services (RDS) solution for internal and external staff. Their goal is to provide telemedicine
          services without managing standalone office workstations. Many staff members moved to telework,
          creating an urgent need for efficient remote access. Because of HIPAA requirements, HUC must
          ensure adherence to established data-protection guidelines.
        </p>
        <p>
          To address these needs, HUC hired IT consultants to evaluate, design, and implement the right
          remote desktop solution.
        </p>

        <h4 id="pro1_2">Scope</h4>
        <p>
          The objective is to implement best-practice RDS controls and address security gaps related to
          standalone workstation management during cyber incidents. The following items are out of scope:
        </p>
        <ul>
          <li>Hardware and firmware infrastructure components</li>
          <li>Network security devices and software from core infrastructure</li>
          <li>Managed services such as databases</li>
          <li>Cloud-based software solutions</li>
        </ul>

        <p>
          <b>Assets not addressed in this project:</b>
        </p>
        <ul>
          <li>Physical facility security</li>
          <li>IP phones</li>
          <li>IoT devices</li>
          <li>Cameras</li>
          <li>Printers</li>
          <li>Medical devices</li>
          <li>Local networking devices and software</li>
        </ul>

        <h4 id="pro1_3" className="pt-3">
          Asset Inventory
        </h4>
        <p>The following diagrams indicate the assets considered in this project:</p>

        <div className="row">
          <div className="col center">
            <img src={data1} alt="Asset inventory diagram 1" className="center img-fluid" height={650} width={550} />
          </div>
          <div className="col center">
            <img src={data3} alt="Asset inventory diagram 2" className="center img-fluid" height={100} width={550} />
          </div>
        </div>
        <div className="row">
          <div className="col pt-3">
            <img src={data2} alt="Asset data duplication chart" className="center img-fluid" height={150} width={400} />
          </div>
          <div className="col pt-3">
            <img src={hardware} alt="Hardware inventory chart" className="center img-fluid" height={110} width={400} />
          </div>
        </div>

        <h2 id="pro2">Problem Definition II</h2>

        <h4 id="pro2_1">Threat Analysis</h4>
        <p>The following diagrams list applicable threats for each identified asset:</p>
        <div className="col center">
          <img src={threat1} alt="Threat analysis matrix" className="center img-fluid" height={850} width={600} />
        </div>
        <div className="col center">
          <img src={threat4} alt="Threat analysis summary" className="center img-fluid" height={400} width={600} />
        </div>

        <p>HUC selected the following response strategies for identified threats:</p>
        <div className="col center pb-5">
          <img src={threat2} alt="Threat response strategy table" className="center img-fluid" height={150} width={500} />
        </div>

        <h4 id="pro2_2">Current Security Posture</h4>
        <p>
          HUC is in the middle of a major technology and infrastructure shift driven by the pandemic.
          Their existing posture has been primarily on-premises and brick-and-mortar dependent. As staff
          moved to telework, current infrastructure became insufficient for business and technology needs.
        </p>
        <p>The following policies were established by their IT provider:</p>
        <ul>
          <li>On-premises storage via SharePoint</li>
          <li>No cloud services (with exception of the EMR)</li>
          <li>On-premises Domain Controller: workstation-server architecture</li>
          <li>No VPN (network isolation)</li>
          <li>No virtualization in place</li>
          <li>Strict firewall rules to prevent direct remote access</li>
          <li>Remote monitoring solution for patching and antivirus</li>
          <li>Monthly patching for workstations, servers, and network equipment</li>
          <li>Strict facility access via keycard systems</li>
          <li>Quarterly staff training</li>
          <li>Password policies managed by HR</li>
          <li>Third-party support agreements for medical devices</li>
        </ul>

        <h2 id="design1">Design &amp; Specification I</h2>

        <h4 id="design1_1">Design Approach</h4>
        <p>
          The solution focuses on strategic IT design aligned with industry best practices, least
          privilege, and need-to-know principles. Only minimum required rights should be granted, often
          for a limited time. This helps reduce exposure of confidential information and supports HIPAA,
          federal, and state compliance goals.
        </p>

        <h4 id="design1_2">Design and Development</h4>
        <p>
          Teams and leadership reviewed access requirements to ensure alignment with HIPAA guidelines.
          Native Active Directory tooling in Windows Server was used for policy and permissions design.
        </p>
        <p>Multi-group user design includes:</p>
        <ul>
          <li>Human Resources security group (main group)</li>
          <li>Manager subgroup</li>
          <li>Staff member subgroup</li>
        </ul>

        <h4 id="design1_3" className="pt-4">
          Encryption and File Password-protection
        </h4>
        <p>
          In addition to least privilege, both data encryption and file password protection are required.
          Encryption helps prevent unauthorized access, while password protection provides an additional
          internal and external control layer during file transfer and delivery.
        </p>

        <h4 id="design1_4">Residual Risk and Other Considerations</h4>
        <p>
          For project scope purposes, administrative and physical safeguards plus residual risks are
          assigned to corresponding HUC teams. This project focuses on HIPAA technical safeguards,
          including controls over access to electronic protected health information (ePHI).
        </p>
        <p>Design objectives across the CIA triad:</p>
        <ul>
          <li>Confidentiality: control access to sensitive data</li>
          <li>Integrity: protect data quality from unauthorized or faulty changes</li>
          <li>Availability: maintain uptime and access for critical services</li>
        </ul>

        <h2 id="design2">Design &amp; Specification II</h2>

        <h4 id="design2_1">Selected Security Controls</h4>
        <p>
          The following diagrams map identified threats to recommended security controls. A full
          vulnerability analysis is recommended under the HIPAA Security Rule.
        </p>
        <div className="col center">
          <img src={asset} alt="Asset threat and control mapping" className="center img-fluid" height={900} width={600} />
        </div>
        <div className="col center">
          <img src={threat3} alt="Selected security controls table" className="center img-fluid" height={500} width={600} />
        </div>
        <div className="col center pb-5">
          <img src={network} alt="Target network architecture diagram" className="center img-fluid" height={550} width={600} />
        </div>

        <h2 id="implement">Implementation</h2>

        <h4 id="implement_1">Selection of Security Control</h4>
        <p>
          This project selects a malware-focused control strategy to prevent, detect, respond to, and
          recover from attacks. Healthcare experienced major ransomware pressure in 2020, making malware
          defense a critical priority.
        </p>
        <p>
          The proposed multilayered control model follows a zero trust principle: <b>Never trust, always
          verify.</b>
        </p>
        <p>Core solution components:</p>
        <ul>
          <li>
            Endpoint Security System to manage and protect endpoints such as desktops, laptops, and
            mobile devices
          </li>
          <li>
            Intrusion Detection System (IDS) to monitor and analyze traffic for suspicious patterns,
            exploits, and vulnerabilities
          </li>
          <li>
            Intrusion Prevention System (IPS) to block malicious inbound and outbound activity and reduce
            communication with compromised hosts
          </li>
          <li>
            Firewall controls for rule-based inbound and outbound traffic governance
          </li>
        </ul>

        <h4 id="implement_2">Implementation of Security Control</h4>
        <p>
          To deliver a cost-effective remote-access model, HUC uses an all-in-one endpoint security,
          IDS, and IPS stack for 35 workstations. Deployment includes endpoint agents for remote desktops,
          a server agent on the RDS server, and centralized cloud management for monitoring and policy
          updates.
        </p>
        <p>
          To maintain HIPAA alignment, strong cybersecurity policies are enforced through policy
          management. This model assumes users access corporate resources from company-issued devices.
        </p>

        <h4 id="implement_3">Summary of Proposed Policies in Accordance with HIPAA Guidelines</h4>
        <p>
          In addition to malware controls, machine learning is recommended to classify applications and
          files as benign or malicious through behavioral analysis and pattern detection.
        </p>

        <b>Endpoint Security</b>
        <ul>
          <li>Advanced heuristics</li>
          <li>Reputation intelligence using live global threat telemetry</li>
          <li>Automatic blocking of unauthorized external devices (with managed exceptions)</li>
          <li>Network traffic restriction, allowing only approved VPN paths</li>
          <li>Machine learning and deep behavioral inspection against malware</li>
          <li>Dynamic threat defense with automated sample submission and analysis</li>
          <li>Silent-mode endpoint agents</li>
          <li>Daily scheduled scans after business hours</li>
        </ul>

        <b>IDS / IPS</b>
        <ul>
          <li>Centralized correlation of log data across systems</li>
          <li>Alerting for suspicious behavior and policy violations</li>
          <li>File integrity monitoring and change alerts</li>
          <li>Traffic pattern monitoring for DDoS-style disruption risks</li>
          <li>Network attack protection through IDS/IPS policy enforcement</li>
        </ul>

        <h2 id="conclusion">Conclusion</h2>
        <p>
          HUC requires a secure and scalable RDS platform for all 35 employees while maintaining HIPAA
          compliance. After threat analysis, the project produced a multilayered malware defense strategy
          built on endpoint security, IDS, IPS, and firewall controls.
        </p>
        <p>
          Implementation consists of endpoint agents on remote desktops, a server agent on the RDS server,
          and cloud-based policy management for centralized operations.
        </p>
        <p>Advantages of the solution:</p>
        <ul>
          <li>Security and functionality: stronger protection with operational usability</li>
          <li>Cost efficiency: right-sized all-in-one approach for a 35-user environment</li>
        </ul>
        <p>
          This capstone provided a practical framework for delivering cost-efficient cybersecurity
          solutions in healthcare environments.
        </p>
      </main>

      <Footer />
    </div>
  );
};

export default UrgentCare;
